import { useMemo } from 'react';
import getLocalizedText from '../../../Utils';

// Helper to find element by idShort in nested structure
const findByIdShort = (elements, idShort) => {
  if (!Array.isArray(elements)) return null;
  for (const el of elements) {
    if (el.idShort === idShort) return el;
    if (el.value) {
      const found = findByIdShort(el.value, idShort);
      if (found) return found;
    }
  }
  return null;
};

export const useGeneralInformation = (submodel, locale = 'en') => {
  return useMemo(() => {
    const elements = submodel?.submodelElements || [];

    const generalCollection = findByIdShort(elements, 'GeneralInformation');
    const generalValue = generalCollection?.value || [];

    // Simple string values (not multi-language)
    const manufacturerName = findByIdShort(generalValue, 'ManufacturerName')?.value ?? '';
    const articleNumber = findByIdShort(generalValue, 'ManufacturerArticleNumber')?.value ?? '';
    const orderCode = findByIdShort(generalValue, 'ManufacturerOrderCode')?.value ?? null;

    // Potentially multi-language values
    const manufacturerLogo = findByIdShort(generalValue, 'ManufacturerLogo')?.value ?? null;
    const productImage = findByIdShort(generalValue, 'ProductImage')?.value ?? null;

    // MultiLanguageProperty - use getLocalizedText
    const productDesignationMlp = findByIdShort(generalValue, 'ManufacturerProductDesignation');
    const productDesignation = productDesignationMlp
      ? getLocalizedText(productDesignationMlp.value, 'N/A', locale)
      : 'N/A';

    // Also localize manufacturerName if it's actually a MultiLanguageProperty
    // (some implementations use MLP even for name)
    const resolvedManufacturerName = (() => {
      const nameEl = findByIdShort(generalValue, 'ManufacturerName');
      if (!nameEl?.value) return '';
      return getLocalizedText(nameEl.value, '', locale);
    })();

    return {
      manufacturerName: resolvedManufacturerName || manufacturerName, // fallback to plain string if not MLP
      manufacturerLogo,
      productDesignation,
      articleNumber,
      orderCode,
      productImage,
    };
  }, [submodel, locale]);
};